import { Box, Typography, Snackbar, Alert } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import QuestionForm from '../components/QuestionForm';
import { UpdateQuestionInput } from '../__generated__/graphql';
import { UPDATE_QUESTION } from '../graphql/updateQuestion';
import { useMutation } from '@apollo/client';
import { QuestionFormStyles } from '../styles/QuestionFormStyles';
import { useState } from 'react';

const EditQuestion = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [updateQuestion] = useMutation(UPDATE_QUESTION);
  const [notification, setNotification] = useState<{
    open: boolean;
    message: string;
    severity: 'success' | 'error';
  }>({
    open: false,
    message: '',
    severity: 'success',
  });

  const handleUpdateQuestion = async (
    updateQuestionInput: UpdateQuestionInput,
  ) => {
    await updateQuestion({
      variables: {
        updateQuestionInput,
      },
    })
      .then(() => {
        setNotification({
          open: true,
          message: 'Question updated successfully!',
          severity: 'success',
        });
        setTimeout(() => navigate('/question-bank'), 1500);
      })
      .catch((error) => {
        console.error('Error updating question:', error);
        setNotification({
          open: true,
          message: 'Failed to update question. Please try again.',
          severity: 'error',
        });
      });
  };

  return (
    <Box sx={QuestionFormStyles.container}>
      <Typography sx={QuestionFormStyles.header}>Edit Question</Typography>
      <QuestionForm
        question={location.state?.question}
        onSubmit={(updateQuestionInput) =>
          handleUpdateQuestion(updateQuestionInput as UpdateQuestionInput)
        }
      />
      <Snackbar
        open={notification.open}
        autoHideDuration={4000}
        onClose={() => setNotification((prev) => ({ ...prev, open: false }))}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert
          onClose={() => setNotification((prev) => ({ ...prev, open: false }))}
          severity={notification.severity}
          sx={{ width: '100%' }}
        >
          {notification.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default EditQuestion;
